import BaseCtrl from 'edge/platform/base/BaseCtrl';
import Submission from 'edge/quoteandbind/common/models/Submission';
import moment from 'moment';

var fn = function fn($scope, $state, $stateParams, LoadSaveService, ModalService, wizardFlowService, qnbCompositeFlowDefn, ViewModelService, viewModelContext, returnStateFn, errorStateFn, effectiveDateStateFn, CampaignDataService, complexQuoteAmaFn) {
    var ctrl = Object.create(BaseCtrl);
    var parentWizardState = 'baseTransactionWizard';

    ctrl.init = function () {
        var stepToStateMapping = {
            returnHome: function returnHome(model) {
                return returnStateFn(model);
            },
            confirmation: function confirmation(model) {
                return ['qnbconfirmation', {
                    quoteSummary: model.value,
                    returnStateInfo: returnStateFn(model.value)
                }];
            },
            error: function error(model) {
                return errorStateFn(model);
            },
            complexQuoteAma: function complexQuoteAma(model) {
                return complexQuoteAmaFn(model);
            },
            effectiveDate: function effectiveDate(model) {
                return effectiveDateStateFn(model);
            }
        };
        var flowfactory = wizardFlowService(qnbCompositeFlowDefn, parentWizardState, stepToStateMapping);

        if ($stateParams.quoteID) {
            // resume draft submission
            var submissionLoadPromise = LoadSaveService.retrieveSubmission($stateParams);
            $scope.submissionLoadPromise = submissionLoadPromise;

            submissionLoadPromise.then(function (submissionData) {
                if ($stateParams.shouldUpdateEffectiveDate && moment(submissionData.baseData.periodStartDate).isBefore(moment(), 'day')) {
                    var now = new Date();
                    submissionData.baseData.periodStartDate = {
                        year: now.getFullYear(),
                        month: now.getMonth(),
                        day: now.getDate()
                    };
                }
                var submission = new Submission(submissionData);
                var submissionVM = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', viewModelContext);
                flowfactory.resume(submissionVM, $stateParams);
            }).catch(function () {
                var errorPromise = ModalService.showError('quoteandbind.controllers.QuoteEntryCtrl.Error retrieving submission', 'quoteandbind.controllers.QuoteEntryCtrl.Sorry, but we can\'t seem to locate a quote with that number and that ZIP code. Please try again.').result;
                errorPromise.then(function () {
                    var returnData = returnStateFn({
                        quoteID: $stateParams.quoteID
                    });
                    // return the home page
                    $state.go(returnData[0], returnData[1]);
                });
            });
        } else if ($stateParams.productCode !== null) {
            var submission = new Submission($stateParams.productCode);

            if ($stateParams.account) {
                submission.baseData.accountHolder = $stateParams.account;
                submission.baseData.accountNumber = $stateParams.account.accountNumber;
                submission.baseData.policyAddress = $stateParams.account.primaryAddress;
            }

            var campaignData = CampaignDataService;
            if (campaignData && campaignData.utm_campaign) {
                submission.baseData.trackingCode = [{
                    codeValue: campaignData.utm_campaign,
                    codeName: 'utm_campaign'
                }];
            }

            var submissionModel = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', viewModelContext);
            flowfactory.start(submissionModel, $stateParams);
        } else {
            window.history.back();
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$stateParams', 'qnb.LoadSaveService', 'ModalService', 'WizardFlowService', 'qnb.CompositeFlowDefn', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.returnStateFn', 'qnb.errorStateFn', 'qnb.effectiveDateStateFn', 'CampaignDataService', 'ama.complexQuoteFn'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/controllers/QuoteEntryCtrl.js
// module id = 839
// module chunks = 0